export default __webpack_public_path__ + "static/media/EndingSpark.c73df05d.svg";